/**
 * The optional Latin store link an admin may choose when creating an online
 * store (R2-D5). Mirrors the backend's `STORE_SLUG_PATTERN`
 * (apps/backend/src/modules/seller/types/store-slug.types.ts) and the seller
 * portal's copy of it (apps/seller/src/modules/auth/lib/store-slug-input.ts) —
 * keep the three in step. Lowercase Latin letters, digits and single hyphens,
 * 3–40 characters, starting and ending with a letter or digit. A reserved or
 * taken link is refused by the server with 409 `STORE_SLUG_TAKEN`; a value
 * outside the pattern with 400.
 */
export const STORE_SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9]|-(?=[a-z0-9])){2,39}$/;

/** The 409 the server answers when the link is reserved or already a store's. */
export const STORE_SLUG_TAKEN = "STORE_SLUG_TAKEN";

/**
 * What the field keeps while the admin types: lowercase, spaces and
 * underscores become hyphens, anything else outside [a-z0-9-] is dropped, and
 * runs of hyphens collapse. A trailing hyphen is kept so typing "my-" then
 * "shop" works; `isValidStoreSlug` refuses it until it is completed.
 */
export function sanitizeStoreSlugInput(value: string): string {
  return value
    .toLowerCase()
    .replace(/[\s_]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-{2,}/g, "-")
    .replace(/^-+/, "")
    .slice(0, 40);
}

export function isValidStoreSlug(value: string): boolean {
  return STORE_SLUG_PATTERN.test(value);
}
